<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Parceiros</div>
                <div class="text text--thin mb-2">Os logotipos incluídos aqui serão exibidos na proposta comercial</div>
                <v-btn @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">handshake</v-icon>Novo parceiro</v-btn>
              </v-col>
              <v-col cols="12" md="5">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
      <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <v-row no-gutters>
              <div class="py-2 px-2">
                <v-form @submit.prevent="applyFilter()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="distribuidor"
                  :items="distribuidores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Distribuidor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="integrador"
                  :items="integradores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Integrador"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
            </v-row>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.par_logo="{ item }">
          <img v-if="item.par_logo" class="parceiro_logo" :src="item.par_logo" :alt="item.par_nome">
          <div v-else>Não possui</div>
        </template>
        <template v-slot:item.par_website="{ item }">
          <a v-if="item.par_website" :class="'text-' + ($vuetify.theme.dark ? 'white' : 'black')" :href="item.par_website" target="_blank">{{item.par_website}}</a>
          <div v-else>Não vinculado</div>
        </template>
        <template v-slot:item.int_dis_nome="{ item }">
          <div>{{item.int_dis_nome}}</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{parceiro.uuid_par_id ? 'Editar parceiro' : 'Novo parceiro'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formParceiros">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="parceiro.par_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0" v-if="$root.Permissions.admin()">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="distribuidorSelecionado"
                :items="distribuidores"
                clearable
                clear-icon="close"
                label="Distribuidor"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando || parceiro.uuid_int_id != null"
                outlined
                @change="getIntegrators(distribuidorSelecionado, true)"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0" v-if="$root.Permissions.admin()">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="parceiro.uuid_int_id"
                :items="integradoresCadastro"
                :rules="[rules.required]"
                clearable
                clear-icon="close"
                label="Integrador"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando  || parceiro.uuid_dis_id != null"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
              <v-text-field
                v-model="parceiro.par_website"
                label="Website"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="parceiro.par_logo"
                prepend-icon="image"
                label="Adicionar logotipo*"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(parceiro.par_logo)"
                outlined
                :rules="[rules.required, rules.size]"
                hint="Tamanho recomendado: 200x100px"
                persistent-hint
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="parceiro.par_logo && !isObject(parceiro.par_logo)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="parceiro.par_logo">
                  <img alt="Logotipo" :src="parceiro.par_logo" class="logotipo">
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover logotipo</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditPartner()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Logotipo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover o logotipo?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Parceiro
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelUsuarioDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Parceiro <b class="text-primary">{{parceiro ? parceiro.par_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelUsuarioDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeUser()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  watch: {
    options: {
      handler () {
        this.getPartners()
      },
      deep: true
    }
  },
  data () {
    return {
      loading: true,
      carregando: false,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogDeletarImagem: false,
      search: '',
      options: {},
      total: 0,
      modulos: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'par_id'
        },
        { text: 'Nome', value: 'par_nome' },
        { text: 'Website', value: 'par_website' },
        { text: 'Imagem', value: 'par_logo' },
        { text: 'Integrador', value: 'int_dis_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      parceiro: {
        par_nome: '',
        par_website: '',
        par_logo: '',
        uuid_int_id: null,
        uuid_dis_id: null
      },
      integrador: null,
      distribuidor: null,
      integradores: [],
      integradoresCadastro: [],
      distribuidorSelecionado: null,
      distribuidores: []
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        integrador: this.integrador ? this.integrador : null,
        distribuidor: this.distribuidor ? this.distribuidor : null,
        type: 'parceiros'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    removeHeader () {
      if (!this.$root.Permissions.admin()) {
        delete this.headers[4]
      }
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }
      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : ''
      )

      this.$router.replace({name: 'Parceiros', query: query}).catch(() => {})

      this.options.page = 1
      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getPartners()
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador

      this.removeHeader()
      this.getDistributors()
      this.getIntegrators(this.distribuidor)
      this.loading = false
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getPartners () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidor && !this.integrador) endpoint += '&distribuidor=' + this.distribuidor
      if (this.integrador) endpoint += '&integrador=' + this.integrador

      await Api.get(`parceiros?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          let info = []
          if (res.data) {
            if (res.data.data.length > 0) {
              res.data.data.map(item => {
                info.push({
                  par_id: item.par_id,
                  par_nome: item.par_nome,
                  par_logo: item.par_logo,
                  par_website: item.par_website,
                  uuid_par_id: item.uuid_par_id,
                  uuid_int_id: item.integrador != null ? item.integrador.uuid_int_id : null,
                  uuid_dis_id: item.distribuidor != null ? item.distribuidor.uuid_dis_id : null,
                  int_dis_nome: item.distribuidor === null && item.integrador === null ? 'Não vinculado' : (item.distribuidor != null ? item.distribuidor.dis_nome : item.integrador.int_nome)
                })
              })
            }
            this.total = res.data.total
          }
          this.dados = info
          this.loading = false
          this.carregando = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os parceiros!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeImagem () {
      this.parceiro.par_logo = ''
      this.parceiro.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditPartner () {
      if (!this.$refs.formParceiros.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'parceiros/novo'
      let editado = false
      if (this.parceiro.uuid_par_id) {
        endpoint = 'parceiros/edita'
        editado = true
      }
      const formData = new FormData()
      Object.keys(this.parceiro).map((key) => {
        if (key === 'par_logo') {
          if (this.$refs.file) {
            formData.append(`par_logo`, this.parceiro.par_logo)
          }
        } else {
          if (this.parceiro[key] != null) {
            formData.append(key, this.parceiro[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Parceiro atualizado com sucesso!' : 'Parceiro cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getPartners()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeUser () {
      this.salvando = true
      Api.delete(`parceiros/remove/${this.parceiro.uuid_par_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getPartners()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover parceiro!',
            color: 'error'
          })
        })
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
          }
        })
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovo (item) {
      this.parceiro = JSON.parse(JSON.stringify(item))
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.parceiro = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelUsuarioDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.parceiro = {
        par_nome: '',
        par_website: '',
        par_logo: ''
      }
      if (this.$refs.formParceiros) {
        this.$refs.formParceiros.resetValidation()
      }
      this.dialogNovo = false
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.logotipo {
  max-height: 250px;
  max-width: 250px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
.parceiro_logo {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Parceiros.vue